<template>
  <el-dialog
    :title="setId ? '编辑学生' : '新增学生'"
    :visible.sync="dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="600px"
    center
  >
    <el-form
      :model="studentForm"
      :rules="rules"
      ref="studentForm"
      label-width="100px"
    >
      <el-form-item label="学生照片" prop="photo">
        <el-upload
          class="avatar-uploader"
          :action="upUrl + '/admin/upload'"
          :name="'image'"
          :data="fileData"
          :show-file-list="false"
          accept="image/*"
          :on-success="handleAvatarSuccess"
        >
          <img
            v-if="studentForm.photo"
            :src="imgUrl + studentForm.photo"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>

      <el-form-item label="姓名" prop="stu_name">
        <el-input
          v-model="studentForm.stu_name"
          placeholder="请输入姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="stu_idcard">
        <el-input
          v-model="studentForm.stu_idcard"
          placeholder="请输入身份证号"
        ></el-input>
      </el-form-item>
      <el-form-item label="电话号码" prop="stu_tel">
        <el-input
          v-model="studentForm.stu_tel"
          placeholder="请输入电话号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="政治面貌" prop="stu_face">
        <el-select v-model="studentForm.stu_face" placeholder="请选择政治面貌" style="width:100%;">
          <el-option
            v-for="item in faceTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="性别" prop="stu_sex">
        <el-select
          v-model="studentForm.stu_sex"
          placeholder="请选择性别"
          style="width: 100%"
        >
          <el-option label="男" :value="1"></el-option>
          <el-option label="女" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="民族" prop="stu_nation">
        <el-select v-model="studentForm.stu_nation" placeholder="请选择民族" style="width:100%;">
          <el-option
            v-for="item in nationList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('studentForm')"
          >取消</el-button
        >
        <el-button
          class="padding-lr-xl"
          type="primary"
          @click="submitForm('studentForm')"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { classStudentAdd } from "@/api/fuse";
import { IMGURL, UPFILE } from "@/config";
import rules from '@/tools/rules'
import {faceTypes,nationList} from '@/tools/utils'

export default {
  name: "studentDialog",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default () {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data () {

    return {
      perList: [],
      faceTypes:faceTypes,
      nationList:nationList,
      studentForm: {
        class_id:'',
        stu_name: '',
        stu_idcard: '',
        stu_sex: '',
        stu_face: '',
        stu_tel: '',
        photo: '',
        stu_nation:'',
      },
      rules: {
        stu_name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        stu_idcard: rules.stu_idcard,
        stu_tel: rules.stu_tel,
        stu_sex: [
          { required: true, message: '请选择性别', trigger: 'change' },
        ],
        stu_face: [
          { required: true, message: '请选择政治面貌', trigger: 'change' },
        ],
        stu_nation: [
          { required: true, message: '请选择民族', trigger: 'change' },
        ],
        photo: [{ required: true, message: "请上传个人正面照", trigger: "change" }],
      },

    }
  },
  computed: {
    fileData () {
      return {
        u_token: this.$store.state.token2
      };
    },
    upUrl () {
      return UPFILE
    },
    imgUrl () {
      return IMGURL
    }
  },
  created () {
  },
  methods: {
    handleAvatarSuccess (res) {
      if (res.code === 1002) {
        this.studentForm.photo = res.data.path
        this.$refs.studentForm.validateField('photo')
      } else {
        this.$message.error(res.data)
      }
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData (formName) {
      let _state = await classStudentAdd(
        this.$route.query.id,
        this.studentForm.stu_name,
        this.studentForm.stu_idcard,
        this.studentForm.stu_sex,
        this.studentForm.photo,
        this.studentForm.stu_tel,
        this.studentForm.stu_face,
        this.studentForm.stu_nation,
        this.setId ? this.setId : ''
      );
      this.$message.success(_state.msg);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }

  },
  watch: {
    setItem () {
      this.studentForm = {
         class_id: this.$route.query.id,
        stu_name: this.setItem.stu_name,
        stu_idcard: this.setItem.stu_idcard,
        stu_sex: this.setItem.stu_sex,
        photo: this.setItem.img,
        stu_tel:this.setItem.stu_phone,
        stu_face:this.setItem.political,
        stu_nation:this.setItem.nation,
      };
    }
  }
}
</script>

<style scoped lang="scss">
</style>